module.exports = __webpack_public_path__ + "media/videos/home/hero-3d18db4a624cf3996937c23f3d0dc802.webm";